var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 296,
    viewBox: "0 0 1920 296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.321,
    x2: 0.757,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57cdd8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 1920,
    height: 296,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 334.474,
    height: 347.667,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 72.249,
    height: 164.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 78.204,
    height: 85.314,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 102.254,
    height: 64.483,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 189.463,
    height: 82.436,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 106.813,
    height: 72.234,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 70.325,
    height: 121.488,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 77.62,
    height: 93.99,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 70.838,
    height: 133.071,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 125.834,
    height: 125.833,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 121.474,
    height: 86.012,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 160.641,
    height: 124.366,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 91.397,
    height: 73.916,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 119.508,
    height: 100.644,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-2",
    "data-name": "Rectangle 27",
    width: 309.952,
    height: 322.177,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-2",
    "data-name": "Rectangle 13",
    width: 66.952,
    height: 152.56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14",
    width: 72.471,
    height: 79.059,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15",
    width: 94.757,
    height: 59.756,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 175.572,
    height: 76.392,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 98.982,
    height: 66.939,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 65.169,
    height: 112.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-2",
    "data-name": "Rectangle 19",
    width: 71.93,
    height: 87.099,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-2",
    "data-name": "Rectangle 20",
    width: 65.645,
    height: 123.315,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-2",
    "data-name": "Rectangle 21",
    width: 116.608,
    height: 116.608,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-2",
    "data-name": "Rectangle 22",
    width: 112.568,
    height: 79.706,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-2",
    "data-name": "Rectangle 23",
    width: 148.863,
    height: 115.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-2",
    "data-name": "Rectangle 24",
    width: 84.696,
    height: 68.497,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-2",
    "data-name": "Rectangle 25",
    width: 110.746,
    height: 93.265,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-3",
    "data-name": "Rectangle 27",
    width: 204.597,
    height: 212.667,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-3",
    "data-name": "Rectangle 13",
    width: 44.194,
    height: 100.704,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-3",
    "data-name": "Rectangle 14",
    width: 47.837,
    height: 52.186,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-3",
    "data-name": "Rectangle 15",
    width: 62.548,
    height: 39.444,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-3",
    "data-name": "Rectangle 16",
    width: 115.894,
    height: 50.426,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-3",
    "data-name": "Rectangle 17",
    width: 65.337,
    height: 44.186,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-3",
    "data-name": "Rectangle 18",
    width: 43.018,
    height: 74.314,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-3",
    "data-name": "Rectangle 19",
    width: 47.48,
    height: 57.494,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-3",
    "data-name": "Rectangle 20",
    width: 43.332,
    height: 81.399,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-3",
    "data-name": "Rectangle 21",
    width: 76.972,
    height: 76.972,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-3",
    "data-name": "Rectangle 22",
    width: 74.305,
    height: 52.613,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-3",
    "data-name": "Rectangle 23",
    width: 98.263,
    height: 76.074,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-3",
    "data-name": "Rectangle 24",
    width: 55.907,
    height: 45.214,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-3",
    "data-name": "Rectangle 25",
    width: 73.102,
    height: 61.563,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-4",
    "data-name": "Rectangle 27",
    width: 119.333,
    height: 124.04,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-4",
    "data-name": "Rectangle 13",
    width: 25.777,
    height: 58.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-4",
    "data-name": "Rectangle 14",
    width: 27.902,
    height: 30.438,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-4",
    "data-name": "Rectangle 15",
    width: 36.482,
    height: 23.006,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-4",
    "data-name": "Rectangle 16",
    width: 67.596,
    height: 29.411,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-4",
    "data-name": "Rectangle 17",
    width: 38.109,
    height: 25.772,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-4",
    "data-name": "Rectangle 18",
    width: 25.091,
    height: 43.345,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-4",
    "data-name": "Rectangle 19",
    width: 27.693,
    height: 33.534,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-4",
    "data-name": "Rectangle 20",
    width: 25.274,
    height: 47.477,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-4",
    "data-name": "Rectangle 21",
    width: 44.895,
    height: 44.895,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-4",
    "data-name": "Rectangle 22",
    width: 43.339,
    height: 30.687,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-4",
    "data-name": "Rectangle 23",
    width: 57.313,
    height: 44.371,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-4",
    "data-name": "Rectangle 24",
    width: 32.609,
    height: 26.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-4",
    "data-name": "Rectangle 25",
    width: 42.638,
    height: 35.908,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gradient_with_circles",
    "data-name": "gradient with circles",
    transform: "translate(0 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1920,
    height: 296,
    transform: "translate(0 -50)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(0 -50)",
    opacity: 0.7,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_element",
    transform: "translate(1567.026 -170.667)",
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(9.574 116.017)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M12.8,212.87a150.4,150.4,0,0,1,11.469-57.817L44.426,163.4l16.441,6.811a111.738,111.738,0,0,0,0,85.313,111.914,111.914,0,0,0,24.178,36.16l-28,28A150.643,150.643,0,0,1,12.8,212.87",
    transform: "translate(-12.796 -155.053)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(49.182 131.176)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M65.73,217.971a110.648,110.648,0,0,1,8.463-42.657l10.073,4.174,5.1,2.109,15.516,6.425,18.55,7.679,20.5,8.492a36.062,36.062,0,0,0,0,27.555l-20.5,8.491-18.55,7.68-15.516,6.425-5.1,2.109-10.073,4.174a110.7,110.7,0,0,1-8.463-42.657",
    transform: "translate(-65.73 -175.313)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(88.334 187.611)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M118.056,266.907l18.55-7.68,20.5-8.491a36,36,0,0,0,47.016,19.476l8.506,20.5,7.679,18.55a78.277,78.277,0,0,1-102.254-42.358",
    transform: "translate(-118.056 -250.736)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(37.713 265.231)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M50.4,386l31.529-31.529A129.351,129.351,0,0,0,222.8,382.511l8.35,20.161,8.719,21.044A173.748,173.748,0,0,1,50.4,386",
    transform: "translate(-50.402 -354.472)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(53.827 22.767)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M71.938,74.681A150.643,150.643,0,0,1,178.751,30.428V70.036A110.706,110.706,0,0,0,136.094,78.5a111.876,111.876,0,0,0-36.16,24.164L87.354,90.1Z",
    transform: "translate(-71.938 -30.428)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(201.773 95.002)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M269.663,164.666l14.2-14.2v-.014l11.883-11.869,11.611-11.611a111.762,111.762,0,0,1,24.164,36.174,111.731,111.731,0,0,1,0,85.314l-10.073-4.175-5.086-2.109-15.516-6.425-18.564-7.679a58.119,58.119,0,0,0-12.624-63.4",
    transform: "translate(-269.663 -126.967)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(174.417 54.397)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M233.1,158.882l8.492-20.5,7.679-18.565L255.7,104.3l2.109-5.087,4.174-10.073,6.81-16.442a129.228,129.228,0,0,1,41.931,28.039l-24.178,24.178-11.883,11.869v.014l-14.2,14.2L244.772,166.69a36.018,36.018,0,0,0-11.669-7.808",
    transform: "translate(-233.103 -72.7)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(263.635 107.298)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M360.8,209.936a110.661,110.661,0,0,0-8.463-42.656l16.442-6.811,20.161-8.349,21.042-8.719a174.367,174.367,0,0,1,0,133.072l-21.042-8.72L368.782,259.4l-16.442-6.811a110.717,110.717,0,0,0,8.463-42.657",
    transform: "translate(-352.34 -143.4)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(174.403 187.597)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M233.084,270.207a36.028,36.028,0,0,0,19.49-19.49l20.5,8.505,18.565,7.68,15.515,6.425,5.086,2.108,10.074,4.175,16.441,6.81,20.161,8.349a151.571,151.571,0,0,1-81.781,81.781l-8.35-20.16-6.81-16.442L257.8,329.876l-2.109-5.1-6.425-15.516-7.679-18.55Z",
    transform: "translate(-233.084 -250.717)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(81.823 62.376)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M109.354,116v-.014a111.852,111.852,0,0,1,36.16-24.164,111.74,111.74,0,0,1,85.314,0L226.654,101.9l-2.109,5.087L218.119,122.5l-7.679,18.565-8.492,20.5a35.956,35.956,0,0,0-39.223,7.808l-15.687-15.687-14.2-14.2v-.014l-11.868-11.854V127.6l-3.9-3.889Z",
    transform: "translate(-109.354 -83.363)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(160.64)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M214.69,44.58V0A174.055,174.055,0,0,1,375.33,107.3l-21.043,8.719-20.161,8.349A129.183,129.183,0,0,0,214.69,44.58",
    transform: "translate(-214.69)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(69.243 229.171)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M92.541,342.339l36.06-36.061A78.224,78.224,0,0,0,183.939,329.2v50.992a129,129,0,0,1-91.4-37.856",
    transform: "translate(-92.541 -306.279)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0 50.921)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M0,124.431A173.733,173.733,0,0,1,37.727,68.054L69.243,99.569l12.58,12.567v.014l7.708,7.708,3.9,3.889v.014L105.3,135.616v.014l14.2,14.2A58.264,58.264,0,0,0,106.885,168.7l-18.55-7.679-15.516-6.425-5.1-2.109L57.645,148.31,41.2,141.5l-20.16-8.348Z",
    transform: "translate(0 -68.054)",
    fill: "#fff"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "circle_element-2",
    "data-name": "circle_element",
    transform: "translate(805.024 166.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62-2",
    "data-name": "Group 62",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61-2",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60-2",
    "data-name": "Group 60",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23-2",
    "data-name": "Group 23",
    transform: "translate(8.872 107.511)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22-2",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21-2",
    "data-name": "Group 21",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M12.8,208.631a139.369,139.369,0,0,1,10.628-53.578l18.683,7.737L57.342,169.1a103.546,103.546,0,0,0,0,79.058,103.71,103.71,0,0,0,22.405,33.509L53.8,307.613A139.6,139.6,0,0,1,12.8,208.631",
    transform: "translate(-12.796 -155.053)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-2",
    "data-name": "Group 26",
    transform: "translate(45.576 121.559)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25-2",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24-2",
    "data-name": "Group 24",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M65.73,214.843a102.536,102.536,0,0,1,7.843-39.529l9.334,3.868,4.726,1.955,14.378,5.954,17.19,7.116,19,7.869a33.418,33.418,0,0,0,0,25.535l-19,7.869-17.19,7.117L87.633,248.55,82.907,250.5l-9.334,3.868a102.588,102.588,0,0,1-7.843-39.529",
    transform: "translate(-65.73 -175.313)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-2",
    "data-name": "Group 29",
    transform: "translate(81.858 173.856)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28-2",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27-2",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M118.056,265.721l17.19-7.117,19-7.869a33.357,33.357,0,0,0,43.569,18.048l7.882,19,7.116,17.19a72.538,72.538,0,0,1-94.757-39.253",
    transform: "translate(-118.056 -250.736)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32-2",
    "data-name": "Group 32",
    transform: "translate(34.948 245.785)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31-2",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30-2",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M50.4,383.69,79.62,354.472a119.868,119.868,0,0,0,130.537,25.983l7.737,18.682,8.08,19.5A161.01,161.01,0,0,1,50.4,383.69",
    transform: "translate(-50.402 -354.472)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35-2",
    "data-name": "Group 35",
    transform: "translate(49.881 21.098)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34-2",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33-2",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M71.938,71.436A139.6,139.6,0,0,1,170.92,30.428v36.7a102.59,102.59,0,0,0-39.529,7.842A103.674,103.674,0,0,0,97.882,97.367L86.224,85.722Z",
    transform: "translate(-71.938 -30.428)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38-2",
    "data-name": "Group 38",
    transform: "translate(186.98 88.037)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37-2",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36-2",
    "data-name": "Group 36",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M269.663,161.9l13.163-13.163v-.013l11.012-11,10.76-10.76a103.568,103.568,0,0,1,22.392,33.522,103.54,103.54,0,0,1,0,79.059l-9.334-3.869-4.714-1.954-14.378-5.954-17.2-7.116a53.858,53.858,0,0,0-11.7-58.753",
    transform: "translate(-269.663 -126.967)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41-2",
    "data-name": "Group 41",
    transform: "translate(161.63 50.409)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40-2",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39-2",
    "data-name": "Group 39",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M233.1,152.564l7.869-19,7.116-17.2,5.954-14.378L256,97.27l3.868-9.334,6.31-15.236a119.754,119.754,0,0,1,38.857,25.983l-22.405,22.405-11.012,11v.013l-13.163,13.163L243.916,159.8a33.378,33.378,0,0,0-10.813-7.235",
    transform: "translate(-233.103 -72.7)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44-2",
    "data-name": "Group 44",
    transform: "translate(244.307 99.431)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43-2",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42-2",
    "data-name": "Group 42",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M360.183,205.058a102.547,102.547,0,0,0-7.843-39.529l15.237-6.312,18.682-7.737,19.5-8.08a161.584,161.584,0,0,1,0,123.316l-19.5-8.081L367.576,250.9l-15.237-6.311a102.6,102.6,0,0,0,7.843-39.529",
    transform: "translate(-352.34 -143.4)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47-2",
    "data-name": "Group 47",
    transform: "translate(161.617 173.843)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46-2",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45-2",
    "data-name": "Group 45",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M233.084,268.778a33.387,33.387,0,0,0,18.061-18.061l19,7.882,17.2,7.117,14.378,5.954,4.713,1.954,9.335,3.868L331.01,283.8l18.683,7.737a140.459,140.459,0,0,1-75.785,75.785l-7.737-18.682-6.311-15.236-3.868-9.334-1.955-4.727-5.954-14.378-7.116-17.19Z",
    transform: "translate(-233.084 -250.717)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50-2",
    "data-name": "Group 50",
    transform: "translate(75.824 57.803)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49-2",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48-2",
    "data-name": "Group 48",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M109.354,113.61V113.6a103.652,103.652,0,0,1,33.509-22.392,103.548,103.548,0,0,1,79.059,0l-3.868,9.334-1.954,4.714-5.955,14.378-7.116,17.2-7.869,19a33.319,33.319,0,0,0-36.347,7.235l-14.537-14.537-13.163-13.163v-.013l-11-10.985v-.013l-3.618-3.6Z",
    transform: "translate(-109.354 -83.363)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53-2",
    "data-name": "Group 53",
    transform: "translate(148.863)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52-2",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51-2",
    "data-name": "Group 51",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43-2",
    "data-name": "Path 43",
    d: "M214.69,41.312V0A161.294,161.294,0,0,1,363.553,99.431l-19.5,8.08-18.682,7.737A119.712,119.712,0,0,0,214.69,41.312",
    transform: "translate(-214.69)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56-2",
    "data-name": "Group 56",
    transform: "translate(64.166 212.369)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55-2",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54-2",
    "data-name": "Group 54",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44-2",
    "data-name": "Path 44",
    d: "M92.541,339.695l33.416-33.417a72.489,72.489,0,0,0,51.281,21.244v47.254a119.546,119.546,0,0,1-84.7-35.08",
    transform: "translate(-92.541 -306.279)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59-2",
    "data-name": "Group 59",
    transform: "translate(0 47.188)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58-2",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57-2",
    "data-name": "Group 57",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    d: "M0,120.3A161,161,0,0,1,34.961,68.054l29.205,29.2L75.824,108.9v.013l7.143,7.143,3.618,3.6v.013l11,10.985v.013l13.163,13.163a53.992,53.992,0,0,0-11.7,17.48L81.858,154.2,67.48,148.249l-4.727-1.954-9.334-3.868-15.236-6.312L19.5,128.378Z",
    transform: "translate(0 -68.054)",
    fill: "#fff"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "circle_element-3",
    "data-name": "circle_element",
    transform: "translate(1302.08 41.333)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62-3",
    "data-name": "Group 62",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61-3",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60-3",
    "data-name": "Group 60",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23-3",
    "data-name": "Group 23",
    transform: "translate(5.857 70.967)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22-3",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21-3",
    "data-name": "Group 21",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-3",
    "data-name": "Path 33",
    d: "M12.8,190.419a92,92,0,0,1,7.016-35.366l12.332,5.107L42.2,164.326a68.35,68.35,0,0,0,0,52.186,68.458,68.458,0,0,0,14.79,22.119L39.865,255.756A92.148,92.148,0,0,1,12.8,190.419",
    transform: "translate(-12.796 -155.053)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-3",
    "data-name": "Group 26",
    transform: "translate(30.085 80.24)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25-3",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24-3",
    "data-name": "Group 24",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34-3",
    "data-name": "Path 34",
    d: "M65.73,201.407a67.683,67.683,0,0,1,5.177-26.093l6.162,2.553,3.12,1.29,9.491,3.93,11.347,4.7,12.541,5.194a22.059,22.059,0,0,0,0,16.855l-12.541,5.194-11.347,4.7-9.491,3.93-3.12,1.29L70.907,227.5a67.717,67.717,0,0,1-5.177-26.093",
    transform: "translate(-65.73 -175.314)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-3",
    "data-name": "Group 29",
    transform: "translate(54.034 114.761)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28-3",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27-3",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35-3",
    "data-name": "Path 35",
    d: "M118.056,260.628l11.347-4.7,12.541-5.194a22.019,22.019,0,0,0,28.76,11.913l5.2,12.541,4.7,11.347a47.882,47.882,0,0,1-62.548-25.91",
    transform: "translate(-118.056 -250.736)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32-3",
    "data-name": "Group 32",
    transform: "translate(23.069 162.241)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31-3",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30-3",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36-3",
    "data-name": "Path 36",
    d: "M50.4,373.758l19.286-19.286a79.124,79.124,0,0,0,86.167,17.151l5.107,12.332,5.334,12.872A106.281,106.281,0,0,1,50.4,373.758",
    transform: "translate(-50.402 -354.472)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35-3",
    "data-name": "Group 35",
    transform: "translate(32.926 13.927)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34-3",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33-3",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37-3",
    "data-name": "Path 37",
    d: "M71.938,57.5a92.148,92.148,0,0,1,65.337-27.069V54.656a67.719,67.719,0,0,0-26.093,5.177A68.434,68.434,0,0,0,89.063,74.614l-7.7-7.687Z",
    transform: "translate(-71.938 -30.428)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38-3",
    "data-name": "Group 38",
    transform: "translate(123.424 58.112)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37-3",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36-3",
    "data-name": "Group 36",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38-3",
    "data-name": "Path 38",
    d: "M269.663,150.027l8.689-8.689v-.009l7.269-7.26,7.1-7.1A68.366,68.366,0,0,1,307.5,149.095a68.346,68.346,0,0,1,0,52.186l-6.162-2.554-3.111-1.29-9.491-3.93-11.355-4.7a35.551,35.551,0,0,0-7.722-38.783",
    transform: "translate(-269.663 -126.967)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41-3",
    "data-name": "Group 41",
    transform: "translate(106.691 33.275)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40-3",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39-3",
    "data-name": "Group 39",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39-3",
    "data-name": "Path 39",
    d: "M233.1,125.417l5.194-12.541,4.7-11.356,3.93-9.491,1.29-3.111,2.554-6.162L254.934,72.7A79.048,79.048,0,0,1,280.583,89.85l-14.79,14.79-7.269,7.26v.009l-8.689,8.689-9.6,9.6a22.032,22.032,0,0,0-7.138-4.776",
    transform: "translate(-233.103 -72.699)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44-3",
    "data-name": "Group 44",
    transform: "translate(161.265 65.634)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43-3",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42-3",
    "data-name": "Group 42",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40-3",
    "data-name": "Path 40",
    d: "M357.517,184.1a67.691,67.691,0,0,0-5.177-26.093l10.057-4.166,12.332-5.107L387.6,143.4a106.66,106.66,0,0,1,0,81.4l-12.871-5.334L362.4,214.359l-10.057-4.166a67.725,67.725,0,0,0,5.177-26.093",
    transform: "translate(-352.34 -143.4)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47-3",
    "data-name": "Group 47",
    transform: "translate(106.682 114.752)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46-3",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45-3",
    "data-name": "Group 45",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41-3",
    "data-name": "Path 41",
    d: "M233.084,262.639a22.038,22.038,0,0,0,11.922-11.922l12.541,5.2,11.356,4.7,9.491,3.93,3.111,1.29,6.162,2.554,10.057,4.166,12.332,5.107a92.716,92.716,0,0,1-50.025,50.025l-5.107-12.332L250.758,305.3l-2.553-6.162-1.29-3.12-3.93-9.491-4.7-11.347Z",
    transform: "translate(-233.084 -250.717)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50-3",
    "data-name": "Group 50",
    transform: "translate(50.051 38.155)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49-3",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48-3",
    "data-name": "Group 48",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42-3",
    "data-name": "Path 42",
    d: "M109.354,103.329v-.009A68.42,68.42,0,0,1,131.473,88.54a68.351,68.351,0,0,1,52.186,0L181.106,94.7l-1.29,3.111-3.931,9.491-4.7,11.356L165.994,131.2A21.994,21.994,0,0,0,142,135.976l-9.6-9.6-8.689-8.689v-.009l-7.26-7.251v-.009l-2.388-2.379Z",
    transform: "translate(-109.354 -83.363)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53-3",
    "data-name": "Group 53",
    transform: "translate(98.263)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52-3",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51-3",
    "data-name": "Group 51",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43-3",
    "data-name": "Path 43",
    d: "M214.69,27.27V0a106.469,106.469,0,0,1,98.263,65.634l-12.872,5.334-12.332,5.107a79.021,79.021,0,0,0-73.059-48.8",
    transform: "translate(-214.69)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56-3",
    "data-name": "Group 56",
    transform: "translate(42.356 140.183)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55-3",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54-3",
    "data-name": "Group 54",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44-3",
    "data-name": "Path 44",
    d: "M92.541,328.336,114.6,306.278a47.849,47.849,0,0,0,33.85,14.023v31.192a78.911,78.911,0,0,1-55.908-23.156",
    transform: "translate(-92.541 -306.278)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59-3",
    "data-name": "Group 59",
    transform: "translate(0 31.148)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58-3",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57-3",
    "data-name": "Group 57",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45-3",
    "data-name": "Path 45",
    d: "M0,102.54A106.272,106.272,0,0,1,23.078,68.054L42.356,87.332l7.7,7.687v.009l4.715,4.715,2.388,2.379v.009l7.26,7.251v.009l8.689,8.689a35.64,35.64,0,0,0-7.721,11.539l-11.347-4.7-9.491-3.93-3.12-1.29-6.162-2.553L25.2,112.98l-12.332-5.107Z",
    transform: "translate(0 -68.054)",
    fill: "#fff"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "circle_element-4",
    "data-name": "circle_element",
    transform: "translate(1106 33.46)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62-4",
    "data-name": "Group 62",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61-4",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60-4",
    "data-name": "Group 60",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23-4",
    "data-name": "Group 23",
    transform: "translate(3.416 41.393)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22-4",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21-4",
    "data-name": "Group 21",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-4",
    "data-name": "Path 33",
    d: "M12.8,175.681a53.658,53.658,0,0,1,4.092-20.628l7.193,2.979,5.866,2.43a39.866,39.866,0,0,0,0,30.438,39.929,39.929,0,0,0,8.626,12.9l-9.988,9.988A53.746,53.746,0,0,1,12.8,175.681",
    transform: "translate(-12.796 -155.053)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-4",
    "data-name": "Group 26",
    transform: "translate(17.547 46.801)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25-4",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24-4",
    "data-name": "Group 24",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34-4",
    "data-name": "Path 34",
    d: "M65.73,190.533a39.477,39.477,0,0,1,3.02-15.219l3.594,1.489,1.82.753,5.536,2.292,6.618,2.74,7.315,3.03a12.866,12.866,0,0,0,0,9.831l-7.315,3.029-6.618,2.74-5.536,2.292-1.82.752-3.594,1.489a39.5,39.5,0,0,1-3.02-15.219",
    transform: "translate(-65.73 -175.314)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-4",
    "data-name": "Group 29",
    transform: "translate(31.516 66.936)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28-4",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27-4",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35-4",
    "data-name": "Path 35",
    d: "M118.056,256.505l6.618-2.74,7.315-3.029a12.843,12.843,0,0,0,16.775,6.949L151.8,265l2.74,6.618a27.928,27.928,0,0,1-36.482-15.112",
    transform: "translate(-118.056 -250.736)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32-4",
    "data-name": "Group 32",
    transform: "translate(13.455 94.629)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31-4",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30-4",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36-4",
    "data-name": "Path 36",
    d: "M50.4,365.721l11.249-11.249a46.15,46.15,0,0,0,50.258,10l2.979,7.193L118,379.176a61.99,61.99,0,0,1-67.6-13.455",
    transform: "translate(-50.402 -354.472)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35-4",
    "data-name": "Group 35",
    transform: "translate(19.204 8.123)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34-4",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33-4",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37-4",
    "data-name": "Path 37",
    d: "M71.938,46.216a53.746,53.746,0,0,1,38.109-15.788V44.559a39.5,39.5,0,0,0-15.219,3.019,39.915,39.915,0,0,0-12.9,8.621l-4.488-4.483Z",
    transform: "translate(-71.938 -30.428)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38-4",
    "data-name": "Group 38",
    transform: "translate(71.989 33.895)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37-4",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36-4",
    "data-name": "Group 36",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38-4",
    "data-name": "Path 38",
    d: "M269.663,140.417l5.068-5.068v-.005l4.24-4.234,4.143-4.143a39.875,39.875,0,0,1,8.621,12.906,39.863,39.863,0,0,1,0,30.438l-3.594-1.49-1.815-.752-5.536-2.292-6.623-2.74a20.736,20.736,0,0,0-4.5-22.62",
    transform: "translate(-269.663 -126.967)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41-4",
    "data-name": "Group 41",
    transform: "translate(62.229 19.408)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40-4",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39-4",
    "data-name": "Group 39",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39-4",
    "data-name": "Path 39",
    d: "M233.1,103.447l3.03-7.315,2.74-6.623,2.292-5.536.753-1.815,1.489-3.594,2.43-5.866a46.107,46.107,0,0,1,14.96,10l-8.626,8.626-4.24,4.234v.005l-5.068,5.068-5.6,5.6a12.85,12.85,0,0,0-4.163-2.786",
    transform: "translate(-233.103 -72.699)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44-4",
    "data-name": "Group 44",
    transform: "translate(94.06 38.282)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43-4",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42-4",
    "data-name": "Group 42",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40-4",
    "data-name": "Path 40",
    d: "M355.36,167.139a39.481,39.481,0,0,0-3.02-15.219l5.866-2.43,7.193-2.979,7.507-3.111a62.211,62.211,0,0,1,0,47.477l-7.507-3.111-7.193-2.979-5.866-2.43a39.5,39.5,0,0,0,3.02-15.219",
    transform: "translate(-352.34 -143.4)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47-4",
    "data-name": "Group 47",
    transform: "translate(62.223 66.931)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46-4",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45-4",
    "data-name": "Group 45",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41-4",
    "data-name": "Path 41",
    d: "M233.084,257.671a12.854,12.854,0,0,0,6.954-6.954l7.315,3.035,6.623,2.74,5.536,2.292,1.815.752,3.594,1.489,5.866,2.43,7.193,2.979A54.078,54.078,0,0,1,248.8,295.612l-2.979-7.193-2.43-5.866-1.489-3.594-.753-1.82-2.292-5.536-2.74-6.618Z",
    transform: "translate(-233.084 -250.717)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50-4",
    "data-name": "Group 50",
    transform: "translate(29.193 22.254)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49-4",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48-4",
    "data-name": "Group 48",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42-4",
    "data-name": "Path 42",
    d: "M109.354,95.008V95a39.907,39.907,0,0,1,12.9-8.621,39.867,39.867,0,0,1,30.438,0L151.2,89.976l-.752,1.815-2.293,5.536-2.74,6.623-3.03,7.315A12.828,12.828,0,0,0,128.4,114.05l-5.6-5.6-5.068-5.068v-.005L113.5,99.151v-.005L112.1,97.758Z",
    transform: "translate(-109.354 -83.363)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53-4",
    "data-name": "Group 53",
    transform: "translate(57.313)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52-4",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51-4",
    "data-name": "Group 51",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43-4",
    "data-name": "Path 43",
    d: "M214.69,15.905V0A62.1,62.1,0,0,1,272,38.282L264.5,41.393,257.3,44.371A46.09,46.09,0,0,0,214.69,15.905",
    transform: "translate(-214.69)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56-4",
    "data-name": "Group 56",
    transform: "translate(24.704 81.763)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55-4",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54-4",
    "data-name": "Group 54",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44-4",
    "data-name": "Path 44",
    d: "M92.541,319.144l12.865-12.866a27.909,27.909,0,0,0,19.743,8.179V332.65a46.026,46.026,0,0,1-32.609-13.506",
    transform: "translate(-92.541 -306.278)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59-4",
    "data-name": "Group 59",
    transform: "translate(0 18.168)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58-4",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57-4",
    "data-name": "Group 57",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45-4",
    "data-name": "Path 45",
    d: "M0,88.168A61.985,61.985,0,0,1,13.46,68.054L24.7,79.3l4.488,4.484v.005l2.75,2.75,1.393,1.388v.005l4.234,4.229v.005l5.068,5.068a20.788,20.788,0,0,0-4.5,6.73l-6.618-2.74L25.98,98.929l-1.82-.752-3.594-1.489L14.7,94.258,7.508,91.279Z",
    transform: "translate(0 -68.054)",
    fill: "#fff"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.270f095494ad52bbd53f5acb7f9fe429.svg";
export { ForwardRef as ReactComponent };